<template>
  <div style="padding: 20px;">
    <p class="realTime">{{realTime}}</p>
    <a-row :gutter="[16,24]">
      <a-col :span="8" v-for="(item,index) in data" :key="index">
        <a-card  :bordered="true" bodyStyle="height:17rem" hoverable >
            <div slot="extra" class="extra">
                <div class="title">
                    <div class="title-left">
                        <a href="#" style="font-size:16px" @click="showModal(item.id)">{{item.roomName}}</a>
                        <p>{{"（预约数:"+item.arrangeCount}}</p>
                        <a  href="#" @click="approve(item)" style="margin-left:0.5rem;color:red" v-if="item.approveCnt>0">{{"待审批数:"+item.approveCnt}}</a>
                        <p>）</p>
                    </div>
                    <a-button type="primary" size="small" icon="plus" v-if="item.apply"
                        @click="$router.push('/admin/office/administration/meetingRooms/list?type=apply&roomId='+item.id+'&roomName='+item.roomName+'&safetyInspector='+item.safetyInspector+'('+item.safetyInspectorPhone+')')"
                        >
                            预约
                    </a-button>
                </div>
                <a-icon type="alert" theme="filled" :style="{color:(getAlert(item.recentMeeting)== 'red' ?'red':'green'),fontSize:'1.2rem'}" />
            </div>

            <p style="margin-top:2rem"><a-empty @click="approve(item)" description="暂无预约" v-show="item.recentMeeting==null"/></p>
            <div class="box" @click="approve(item)" v-show="item.recentMeeting!=null">
                <div class="card-title">
                    <p style="font-size:1rem;font-weight:bold">{{getTitle(item.recentMeeting)}}</p>
                    <a-statistic-countdown v-show="getTitle(item.recentMeeting) == '当前会议'" valueStyle="color:red" :value="getDeadline(item.recentMeeting)" format="D 天 H 时 m 分 s 秒" prefix='（' suffix='后结束）' @finish="fetch()"/>
                    <a-statistic-countdown v-show="getTitle(item.recentMeeting) == '下一会议'" valueStyle="color:green" :value="getDeadline(item.recentMeeting)" format="D 天 H 时 m 分 s 秒" prefix='（' suffix='后开始）' @finish="fetch()"/>
                </div>
                <a-descriptions>
                    <a-descriptions-item label="会议时间" span="3">
                        {{item.recentMeeting!=null?item.recentMeeting.startTime.substr(0,16)+'至'+item.recentMeeting.endTime.substr(0,16):''}}
                    </a-descriptions-item>
                    <a-descriptions-item label="会议名称" span="3">
                        {{item.recentMeeting!=null?item.recentMeeting.meetingName:''}}
                    </a-descriptions-item>
                    <a-descriptions-item label="参会人数" span="1">
                        {{item.recentMeeting!=null?item.recentMeeting.peopleNum:''}}
                    </a-descriptions-item>
                    <a-descriptions-item label="预约联系人" span="2">
                        {{item.recentMeeting!=null?item.recentMeeting.orderPeople+( (item.recentMeeting.orderPeoplePhone == null ||item.recentMeeting.orderPeoplePhone == '') ?'' : '('+item.recentMeeting.orderPeoplePhone+')'):''}}
                    </a-descriptions-item>
                    <a-descriptions-item label="申请时间" span="3">
                        {{item.recentMeeting!=null?item.recentMeeting.createTime.substr(0,16):''}}
                    </a-descriptions-item>
                    <a-descriptions-item label="安全检查人" span="3">
                        {{(item.safetyInspector!=null && item.safetyInspector!='')?item.safetyInspector+'('+item.safetyInspectorPhone+')':''}}
                    </a-descriptions-item>
                </a-descriptions>
            </div>
            
        </a-card>
      </a-col>
    </a-row>
    <div>
        <a-modal v-model="visible" width='50rem' title="会议室详情" >
            <template slot="footer">
                <a-button key="back" @click="handleOk">
                取消
                </a-button>
            </template>

            <div class="info-main">      
                <div class="input-box">
                    <p>安全员姓名：</p>
                    <a-input class="input" :value="info.safetyInspector"  disabled />
                </div>
                <div class="input-box">
                    <p>安全员电话：</p>
                    <a-input class="input" :value="info.safetyInspectorPhone"  disabled />
                </div>
                <!-- <div class="input-box">
                    <p>预约数：</p>
                    <a-input class="input" :value="info.arrangeCount"  disabled />
                </div> -->
                <div class="large-input-box">
                    <p>申请人类型：</p>
                    <a-input class="input" :value="info.applyUserTypeName"  disabled />
                </div>
                <div class="large-input-box">
                    <p>申请人：</p>
                    <a-input class="input" :value="info.applyUsers"  disabled />
                </div>
                <div class="large-input-box">
                    <p>审核人：</p>
                    <a-input class="input" :value="info.approveUsers"  disabled />
                </div>
            </div>
        </a-modal>
    </div>
  </div>
</template>
<script>
import { list,meetingRoomInfo } from '@/baseAPI/office/meetingRooms'
import { getDicts } from '@/baseAPI/dictionary'
import { getTeacher } from '@/baseAPI/facultyTeacher'

export default {
        name: '',
        components: {
            
        },
        data () {
            return {
                data:[],
                type:'color:green;fontSize:1.5rem',
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                },
                realTime:'',
                visible: false,
                rylb:{},
                js:[],
                info:{
                    roomName: "",
	                roomPlace: null,
                    roomDesc: null,
                    safetyInspector: "",
                    safetyInspectorPhone: "",
                    currentStatus: null,
                    arrangeCount: null,
                    applyUserTypes: "",
                    applyUserTypeName: "",
                    applyUserIds: null,
                    applyUsers:null,
                    approveUserIds: "",
                    approveUsers:"",
                    recentMeeting: null
                },
                userId:'',
                userType:'',
            }
        },
        mounted () {
            this.userId=this.$store.state.user.userId
            this.userType=this.$store.state.user.type
            this.fetch()
            // 页面加载完后显示当前时间
            this.realTime = this.dealWithTime(new Date())
            // 定时刷新时间
            let _this = this
            // 定时器
            this.timer = setInterval(function () {
                _this.realTime = _this.dealWithTime(new Date()) // 修改数据date
            }, 1000)

            getDicts({dataCode:'RYLB',status:true}).then(res=>{
                res.data.dicts.forEach((item)=>{
                    let code = item.dataCode;
                    let name = item.dataName;
                    this.rylb[code] = name;
                })
            })
            getTeacher().then(res=>{
                res.data.forEach((item)=>{
                    this.js[item.teacherId]=item
                })
            })
        },
        methods:{
            approve(item){
                if(item.approve){
                    this.$router.push('/admin/office/administration/meetingRooms/list?type=approve&roomId='+item.id+'&roomName='+item.roomName+'&safetyInspector='+item.safetyInspector+'('+item.safetyInspectorPhone+')')
                }else if(item.apply){
                    this.$router.push('/admin/office/administration/meetingRooms/list?type=apply&roomId='+item.id+'&roomName='+item.roomName+'&safetyInspector='+item.safetyInspector+'('+item.safetyInspectorPhone+')')
                }else{
                    this.$router.push('/admin/office/administration/meetingRooms/list?roomId='+item.id+'&roomName='+item.roomName+'&safetyInspector='+item.safetyInspector+'('+item.safetyInspectorPhone+')')

                }
            },
            showModal(roomId) {
                this.roomInfo(roomId)
                this.visible = true;
                this.$router
            },
            handleOk(e) {
                console.log(e);
                this.visible = false;
            },
            roomInfo(roomId){
                meetingRoomInfo(roomId).then(res=>{
                    this.info=res.data
                    if(this.info.applyUserTypes){
                        this.info.applyUserTypes.split(',').forEach((item)=>{
                            this.info.applyUserTypeName += this.rylb[item] +';'                            
                        })
                        this.info.applyUserTypeName = this.info.applyUserTypeName.replace("undefined","")
                    }
                    if(this.info.applyUserIds){
                        this.info.applyUserIds.split(',').forEach((item)=>{
                            if(this.js[item]){
                                this.info.applyUsers += this.js[item].teacherName +';'                            
                            }
                        })
                        this.info.applyUsers = this.info.applyUsers.replace("undefined","")
                    }
                    if(this.info.approveUserIds){
                        this.info.approveUserIds.split(',').forEach((item)=>{
                            this.info.approveUsers += this.js[item].teacherName +';'                            
                        })
                        this.info.approveUsers = this.info.approveUsers.replace("undefined","")
                    }
                })
            },
            fetch() {
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.data.forEach((item)=>{
                        // if(item.applyUserIds != null && item.applyUserIds.indexOf(this.userId) < 0 && this.userType!='admin'){
                        //     item['apply']=false
                        // }else if(item.applyUserTypes != null && item.applyUserTypes.indexOf(this.userType) < 0 && this.userType!='admin'){
                        //     item['apply']=false
                        // }else{
                        //     item['apply']=true
                        // }
                        if(item.applyUserIds || item.applyUserTypes){
                            console.log("usertype:"+this.userType)
                            console.log("userId"+this.userId)
                            if(item.applyUserTypes.indexOf(this.userType) > -1 || item.applyUserIds.indexOf(this.userId) > -1){
                                item['apply']=true
                            }else{
                                item['apply']=false
                            }
                        }else{
                            item['apply']=true
                        }

                        if(item.approveUserIds  && item.approveUserIds.indexOf(this.userId) < 0 && this.userType!='admin'){
                            item['approve']=false
                        }else{
                            item['approve']=true
                        }
                    })
                })
            },
            getDeadline(recentMeeting){
                let now = this.formatDate(new Date);
                let deadline
                if(recentMeeting != null && now >= recentMeeting.startTime && now <= recentMeeting.endTime){
                    deadline = new Date(recentMeeting.endTime).getTime()
                }else if(recentMeeting != null && now < recentMeeting.startTime){
                    deadline = new Date(recentMeeting.startTime).getTime()
                }
                return deadline
            },
            getTitle(recentMeeting){
                let now = this.formatDate(new Date);
                let title
                if(recentMeeting != null && now >= recentMeeting.startTime && now <= recentMeeting.endTime){
                    title = '当前会议'
                }else if(recentMeeting != null && now < recentMeeting.startTime){
                    title = '下一会议'
                }
                return title
            },
            getAlert(recentMeeting){
                let now = this.formatDate(new Date);
                let style = ''
                if(recentMeeting != null && now >= recentMeeting.startTime && now <= recentMeeting.endTime){
                    style = 'red'
                }else if(recentMeeting != null && now < recentMeeting.startTime){
                    style = 'green'
                }
                return style
            
            },
            formatDate (date) {
                let myyear = date.getFullYear();
                let mymonth = date.getMonth() + 1;
                let myweekday = date.getDate();
                let myHour = date.getHours();
                let myMin = date.getMinutes();
                let mySec = date.getSeconds();

                if (mymonth < 10) {
                    mymonth = '0' + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = '0' + myweekday;
                }
                if (myHour < 10) {
                    myHour = '0' + myHour;
                }
                if (myMin < 10) {
                    myMin = '0' + myMin;
                }
                if (mySec < 10) {
                    mySec = '0' + mySec;
                }
                return (myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec);
            },
            dealWithTime (data) {
                let formatDateTime
                let Y = data.getFullYear()
                let M = data.getMonth() + 1
                let D = data.getDate()
                let H = data.getHours()
                let Min = data.getMinutes()
                let S = data.getSeconds()
                let W = data.getDay()
                H = H < 10 ? ('0' + H) : H
                Min = Min < 10 ? ('0' + Min) : Min
                S = S < 10 ? ('0' + S) : S
                switch (W) {
                    case 0:
                    W = '天'
                    break
                    case 1:
                    W = '一'
                    break
                    case 2:
                    W = '二'
                    break
                    case 3:
                    W = '三'
                    break
                    case 4:
                    W = '四'
                    break
                    case 5:
                    W = '五'
                    break
                    case 6:
                    W = '六'
                    break
                    default:
                    break
                }
                formatDateTime = Y + '年' + M + '月' + D + '日 ' + H + ':' + Min + ':' + S + ' 星期' + W
                return formatDateTime
            }
        },
        destroyed () {
            if (this.timer) { 
                clearInterval(this.timer)
            }
        }
}
</script>
<style scoped>
    .extra{
        display:flex;
    }

    .title{
        display:flex;
        width: 25rem;

    }

    .title-left{
        display:flex;
        flex-direction:row;
        justify-content:flex-start;
    }

    .card{
        height: 20rem;
    }
    .box{
        margin-left: 1rem;
    }
    .card-title{
        display: flex;
        margin-bottom: 1rem;
    }
    .realTime{
        width: 100%;
        font-weight: bold;
        text-align: right;
        font-size: 1.5rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 50%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .large-input-box{
        width: 100%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .large-input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .large-input-box .input{
        width: calc(100% - 10rem);
    }
</style>